import { ModuleRegistry } from "ag-grid-community";
import { AllEnterpriseModule, LicenseManager } from "ag-grid-enterprise";

// Register all enterprise modules
ModuleRegistry.registerModules([AllEnterpriseModule]);

// Set license key - replace with your actual license key
// LicenseManager.setLicenseKey("YOUR_LICENSE_KEY_HERE");
